import BaseLayout from "../components/layout/layout-with-sider/BaseLayout";
import {Card} from "antd";
import ProjectUploader from "../app-components/ProjectUploader";
import React from "react";
import ProjectList from "../app-components/ProjectList";
import useUploadProject from "../hooks/useUploadProject";

export default function ProjectListPage() {
    const onUploadProject = useUploadProject()

    return (
        <BaseLayout>
            <Card
                title={(
                    <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                        <>Upload Project</>
                    </div>
                )}
            >
                <ProjectUploader
                    onUploadProject={onUploadProject}
                />
                <br/>
                <ProjectList />
            </Card>
        </BaseLayout>
    )
}